import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { baseStyles, rootVariablesStyles } from '@/styles';

@customElement('fg-toggle')
export class FgToggle extends LitElement {
  @property({ type: Boolean })
  checked: boolean = false;

  @property({ type: String })
  label?: string;

  @property({ type: Boolean })
  showLabel?: boolean;

  toggle() {
    this.checked = !this.checked;
    this.dispatchEvent(
      new CustomEvent('toggle-event', {
        detail: {
          checked: this.checked,
        },
      }),
    );
  }

  render() {
    return html`
      <button
        type="button"
        class="container"
        @click=${this.toggle}
        role="switch"
      >
        <div
          class="toggle ${classMap({ active: this.checked })}"
          aria-checked=${this.checked}
        >
          <span aria-hidden="true" class="toggle-handle"></span>
        </div>
        <span class=${classMap({ 'sr-only': !this.showLabel })}>
          ${this.label ?? nothing}
        </span>
      </button>
    `;
  }

  static styles = [
    baseStyles,
    rootVariablesStyles,
    css`
      .container {
        display: flex;
        gap: 16px;
        align-items: center;
      }

      .toggle {
        display: inline-block;
        position: relative;
        width: 36px;
        height: 16px;
        border-radius: 8px;
        background-color: var(--fg-gray--300, var(--fg-fallback-gray--300));
        cursor: pointer;
      }

      .container:focus-visible .toggle {
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 2px;
        outline-color: var(--fg-primary, var(--fg-fallback-primary));
      }

      .toggle.active {
        background-color: var(--fg-success, var(--fg-fallback-success));
      }

      .toggle-handle {
        position: absolute;
        top: -2px;
        left: 0px;
        width: 20px;
        height: 20px;
        border: #e5e8eb solid 1px;
        box-shadow: 0px 1px 2px 0px #0000000f;
        border-radius: 50%;
        background-color: #fff;
        transition: transform 0.3s;
      }

      .toggle.active .toggle-handle {
        transform: translateX(16px);
      }
    `,
  ];
}
